import { render, staticRenderFns } from "./EmoteCategory.vue?vue&type=template&id=5f739bee&scoped=true&"
import script from "./EmoteCategory.vue?vue&type=script&lang=js&"
export * from "./EmoteCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f739bee",
  null
  
)

component.options.__file = "EmoteCategory.vue"
export default component.exports